import whatIsCfdTradingJson from './content/what-is-cfd-trading.json';

export const whatIsCfdTradingMock = {
    layoutType: 2,
    data: {
        name: 'what-is-cfd-trading',
        areasList: [
            {
                id: 1,
                name: 'WhatIsCfdTradingPage',
                componentName: 'Comp:WhatIsCfdTradingPage',
                content: JSON.stringify(whatIsCfdTradingJson)
            }
        ]
    }
};
